<div class="d-flex">
  @if (solrDataOption) {
    @if (!solrDataOption.allowMultipleSelections) {
      <rl-single-value-input [solrDataOption]="solrDataOption" (onChange)="addValue($event)">
      </rl-single-value-input>
    } @else {
      <rl-single-value-input [solrDataOption]="solrDataOption" (onChange)="workingValue = $event"
        [values]="[workingValue]" (onEnter)="addWorkingValue()">
      </rl-single-value-input>
      <button type="button" class="btn btn-sm btn-outline" (click)="addWorkingValue()" [disabled]="!isValid(workingValue)"
        title="Add Working Value">
        <i class="far fa-plus"></i>
      </button>
    }
  }
  <div class="flex-grow-1 ms-2">
    @for (value of values; track value; let i = $index) {
      <rl-chip (onRemove)="removeValue(i)">
        {{value}}
      </rl-chip>
    }
  </div>
</div>

